import React, { FC, useCallback, useMemo } from "react"
import { Box, Button, Flex, Heading, SimpleGrid, Text, useToken } from "@chakra-ui/react"
import { ALL_VARIANT_TEXT, AllVariantButton } from "~/components/shared/WelcomeBlur"
import { TT, TTString } from "~/components/shared/AttributedString"
import type { VariantProperties } from "~/generated/interview_service"

type WelcomeSelectPageProps = {
  title: TTString
  description: TTString
  image: string
  next: (answers: string[]) => void
  variants: VariantProperties[]
  selectTitle: TTString
}

export const WelcomeSelect4Page: FC<WelcomeSelectPageProps> = ({
  next,
  title,
  image,
  variants: _variants,
  selectTitle,
}) => {
  const handleChange = useCallback(
    (selected: string) => {
      next([selected])
    },
    [next]
  )

  const variants = useMemo(() => _variants.filter((v) => v.text !== ALL_VARIANT_TEXT), [_variants])
  const allVariantsExist = variants.length !== _variants.length
  const [backgroundColor] = useToken("colors", ["Base/neutralSecondary"])

  return (
    <Flex
      direction="column"
      justifyContent="flex-end"
      flexGrow={1}
      alignItems="center"
      padding={6}
      backgroundImage={`linear-gradient(transparent 0%, transparent 30%, ${backgroundColor} 55%), url(${image})`}
      backgroundSize="100%, 100%"
      backgroundRepeat="no-repeat"
    >
      <Heading mt={305} mb={6} as="h1" size="Header/Primary" w="320px" textAlign="center">
        <TT>{title}</TT>
      </Heading>
      <Flex direction="column" gap={4}>
        <Box textAlign="center" opacity={0.7} textStyle="Subtitle/Secondary">
          <TT>{selectTitle}</TT>
        </Box>
        <SimpleGrid columns={2} spacing={[2, 2]} w="full">
          {variants.map((v, i) => {
            return (
              <Button
                variant="inverted"
                paddingX={6}
                paddingY={3}
                minW="full"
                onClick={() => handleChange(v.text)}
                whiteSpace="pre-line"
                key={i}
                shadow="LoviShort"
              >
                <Text textStyle="Subtitle/Primary">{v.text}</Text>
              </Button>
            )
          })}
        </SimpleGrid>
        {allVariantsExist && (
          <AllVariantButton
            color="Base/baseSecondary"
            iconColor="Base/baseTertiary"
            iconBgColor="Base/neutralPrimary"
            onClick={() => handleChange(ALL_VARIANT_TEXT)}
          />
        )}
      </Flex>
    </Flex>
  )
}
